// extracted by mini-css-extract-plugin
export var borderRadius = "_gi-4";
export var large = "_gi-3";
export var logoContainer = "_gi-0";
export var nameLogo = "_gi-2";
export var small = "_gi-1";